<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue: keepOrder">
      <h5 class="transaction-date">{{ day.key }}</h5>
      <div class="transaction-item" *ngFor="let transaction of day.value">
        <div class="col-9 col-lg-8 text-start d-flex flex-column justify-content-center gap-1 gap-lg-2">
          <div class="fw-bold text-black transaction-text">
            {{ transaction.TransactionDescription || transaction.DescriptionText }}
          </div>

          <div class="transaction-subtext fw-bold text-info">
            {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: 'hh:mm a' | uppercase }}
          </div>
        </div>
        <div class="col-3 col-lg-4 text-end pt-2">
          <div class="fw-bold font-size-12 text-capitalize" [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-error'">
            {{ transaction.Amount >= 0 ? '+' : ''
            }}{{ transaction.Amount | FortressCurrencyPipe: (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
          </div>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        ((!transactions || !hasTransactions) && transactionType === transactionTypes.loyalty) ||
        ((!transactions || !hasTransactions) && transactionType === transactionTypes.ecash)
      "
    >
      <div class="no-items w-100 text-center rounded pt-5 pb-4 mt-4 bg-white">
        <div
          class="svg svg-info vs-svg ms-auto me-auto"
          fgbAnimateSvg
          [inlineSVG]="'assets/images/placeholders/Activity.svg'"
        ></div>
        <p class="text-black text-center font-size-14 mt-2 mb-0">{{ 'no.activity.placeholder.list.title' | translate }}</p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
